import React, { useState, useEffect } from 'react';
import { Stepper, Step, StepLabel, Button, Grid, Paper, Typography, Box, Divider, TextField, FormControlLabel, Checkbox } from '@mui/material';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import API_URL from '../ApiUrl/ApiUrl';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Car_booking = () => {
    const [activeStep, setActiveStep] = useState(0);
    const [start_date, setStartDate] = useState(null);
    const [end_date, setEndDate] = useState(null);
    const [startTime, setStartTime] = useState('10:00 AM');
    const [endTime, setEndTime] = useState('10:00 AM');
    const [email, setEmail] = useState('');
    const [fname, setFirstName] = useState('');
    const [lname, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [dob, setDob] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);
    const { id } = useParams();
    const [openDetails, setOpenDetails] = useState(false);
    const [cars, setCars] = useState([]);
    const [selectedExtras, setSelectedExtras] = useState([]);
    const [uid, setUid] = useState(null);

    useEffect(() => {
        const userid = localStorage.getItem("user_id");
        setUid(userid);
    }, []);

    useEffect(() => {
        const fetchCars = async () => {
            try {
                const response = await axios.get(`${API_URL}/car/${id}`);
                console.log(response.data)
                setCars(response.data);
            } catch (error) {
                console.error('Error fetching cars:', error);
            }
        };
        fetchCars();
    }, [id]);

 // Function to calculate the date difference
 const calculateDateDifference = (start, end) => {
    if (!start || !end) return 1; 

    const startDate = new Date(start);
    const endDate = new Date(end);

    if (isNaN(startDate) || isNaN(endDate)) {
        console.error("Invalid date(s) provided");
        return 1; 
    }

    const differenceInTime = endDate - startDate;
    const differenceInDays = Math.max(Math.ceil(differenceInTime / (1000 * 3600 * 24)), 1);

    return differenceInDays;
};

const dateDifference = calculateDateDifference(start_date, end_date);
console.log("Date Difference:", dateDifference);

const carPrice = cars?.carPrice ? Number(cars?.carPrice.replace(/,/g, '')) : 0;
console.log("Car Price:", carPrice);

const discount = cars?.discount ? parseFloat(cars.discount.replace('%', '')) : 0;
console.log("Discount:", discount);

const updatedPrice = carPrice && !isNaN(carPrice) ? carPrice * dateDifference : 0;
console.log("Updated Car Price:", updatedPrice);


const discountAmount = discount > 0 ? (updatedPrice * discount) / 100 : 0;
console.log("Discount Amount:", discountAmount);


const totalExtrasPrice = selectedExtras.reduce((acc, extra) => acc + extra.price, 0);
console.log("Extra Price Total:", totalExtrasPrice);

// Calculate the total price after discount and adding the price for selected extras
const totalPrice = updatedPrice - discountAmount + totalExtrasPrice;
console.log("Total Price:", totalPrice);



    const handleStepChange = (stepIndex) => setActiveStep(stepIndex);

    const handleSubmit = async () => {
        const duration = calculateDateDifference(start_date, end_date);
        const bookingData = {
            carId: id,
            userId: uid,
            start_date,
            end_date,
            startTime,
            endTime,
            updatedPrice,
            fname,
            lname,
            email,
            phone,
            dob,
            duration,
            tripExtra: selectedExtras,
        };
        console.log(bookingData)

        try {
            const response = await axios.post(`${API_URL}/carbook`, bookingData);
            toast.success("your booking is Confirm !", {
                position: "top-center"
            })
        } catch (error) {
            toast.error("faild to booking", {
                position: "top-center"
            })
        }
        setFirstName("")
        setLastName("")
        setEmail("")
        setPhone("")
        setDob("")
        setPhone("")

    };

    const handleNext = () => setActiveStep((prevStep) => prevStep + 1);
    const handleBack = () => setActiveStep((prevStep) => prevStep - 1);
    const handleToggleDetails = () => setOpenDetails(!openDetails);



    
    const extras = [
        { title: 'Car Seat', description: 'Toddler Front Facing Seat', price: 15, name: 'carSeat' },
        { title: 'Baby Car Seat', description: 'Rear Facing Seat', price: 15, name: 'babyCarSeat' },
        { title: 'Prepaid Fuel', description: 'Prepaid fuel is only sold in full tanks', price: 60, name: 'prepaidFuel' },
        { title: 'CDW', description: 'Coverage insurance offered for the duration of your trip', price: 20, name: 'cdw' },
    ];
     
      const handleExtraChange = (event) => {
        const { name, checked } = event.target;
        const extra = extras.find((extra) => extra.name === name);

        setSelectedExtras((prev) =>
            checked ? [...prev, extra] : prev.filter((extra) => extra.name !== name)
        );
    };
    return (
        <>
            <div className="transper" style={{ width: "100%", height: "100px" }}>
            </div>
            <ToastContainer />
            <div className="container" style={{ marginTop: '40px', padding: '20px' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Grid container spacing={3} style={{boxShadow: "0"}}>
                      

                        {/* Main Section */}
                        <Grid item xs={12} md={8} className='shadow border-0'>
                              {/* Stepper */}
                      
                            <Stepper activeStep={activeStep} alternativeLabel className='col-sm-12 p-0'>
                                {['Dates & Time', 'Checkout'].map((label, index) => (
                                    <Step key={label} onClick={() => handleStepChange(index)}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        
                            {activeStep === 0 && (
                                <Paper style={{ padding: '20px' }} className='border-0'>
                                    <Typography variant="h6">Dates & Time</Typography>
                                    <Divider style={{ margin: '10px 0' }} />
                                    <Typography>Select your trip dates:</Typography>
                                    <Box display="flex" className="calender" justifyContent="space-between" mt={2}>
                                        <Box>
                                            <Typography>Start Date:</Typography>
                                            <StaticDatePicker
                                                displayStaticWrapperAs="desktop"
                                                value={start_date}
                                                onChange={(date) => setStartDate(date)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <TextField
                                                label="Start Time"
                                                type="time"
                                                value={startTime}
                                                onChange={(e) => setStartTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                style={{ marginTop: '10px' }}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography>End Date:</Typography>
                                            <StaticDatePicker
                                                displayStaticWrapperAs="desktop"
                                                value={end_date}
                                                onChange={(date) => setEndDate(date)}
                                                renderInput={(params) => <TextField {...params} />}
                                            />
                                            <TextField
                                                label="End Time"
                                                type="time"
                                                value={endTime}
                                                onChange={(e) => setEndTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{ shrink: true }}
                                                style={{ marginTop: '10px' }}
                                            />
                                        </Box>
                                    </Box>
                                    <div className="d-flex" style={{ float: "end" }}>
                                        <div className="btn btn-danger mt-4">Cancel</div>
                                        <button
                                            className='btn btn-primary mt-4 ms-3'
                                            onClick={handleNext}
                                            disabled={!start_date || !end_date}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                </Paper>
                            )}

             {/* {activeStep === 1 && (
                <Paper style={{ padding: '20px', marginTop: '20px' }}>
                    <Typography variant="h6">Trip Extras</Typography>
                    <Typography variant="body2" style={{ marginBottom: '10px' }}>
                        These optional extras are offered for your convenience.
                    </Typography>

                    {extras.map((extra, index) => (
                        <Box key={index} display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                            <Box>
                                <FormControlLabel
                                    control={<Checkbox name={extra.name} onChange={handleExtraChange} />}
                                    label={
                                        <Box>
                                            <Typography>{extra.title}</Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {extra.description}
                                            </Typography>
                                        </Box>
                                    }
                                />
                            </Box>
                            <Typography>{`TZS${extra.price}/trip`}</Typography>
                        </Box>
                    ))}

                 
                    <div className="d-flex" style={{ float: "end" }}>
                        <div className="btn btn-danger mt-4">Cancel</div>
                        <button
                            className='btn btn-primary mt-4 ml-3'
                            onClick={handleNext}
                            disabled={!start_date || !end_date}
                        >
                            Continue
                        </button>
                    </div>
                </Paper>
            )} */}

                            {activeStep === 1 && (
                                <Paper style={{ padding: '20px' }}>
                                    <Typography variant="h6">Checkout</Typography>
                                    <Divider style={{ margin: '10px 0' }} />
                                    <Box display="flex" flexDirection="column" gap={2}>
                                        <TextField label="First Name" value={fname} onChange={(e) => setFirstName(e.target.value)} fullWidth required />
                                        <TextField label="Last Name" value={lname} onChange={(e) => setLastName(e.target.value)} fullWidth required />
                                        <TextField label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth required />
                                        <TextField label="Phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} fullWidth required />
                                        <TextField label="Date of Birth" type="date" value={dob} onChange={(e) => setDob(e.target.value)} fullWidth required InputLabelProps={{ shrink: true }} />
                                        <FormControlLabel
                                            control={<Checkbox checked={termsAccepted} onChange={(e) => setTermsAccepted(e.target.checked)} color="primary" />}
                                            label="I accept the terms and conditions"
                                        />
                                        <Box display="flex" justifyContent="flex-end" mt={2}>
                                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!termsAccepted || !fname || !lname || !email || !phone || !dob}>
                                                Submit
                                            </Button>
                                        </Box>
                                    </Box>
                                </Paper>
                            )}
                        </Grid>

                        {/* Summary Section */}
                        <Grid item xs={12} md={4} className='shadow'>
                            <Paper style={{ padding: '20px' , boxShadow: "0" }}>
                                <Carousel showThumbs={false} autoPlay infiniteLoop>
                                    {cars?.images?.map((img, index) => (
                                        <div key={index}>
                                            <img src={img} alt=""/>
                                        </div>
                                    ))}
                                </Carousel>
                                <Typography variant="h6" className='mt-4'>{cars?.carName}</Typography>
                                <hr />
                              
                                <Typography>Price: TZS {cars?.carPrice}</Typography>
                                <hr />
                             
                                <Typography><strong>Start Date:</strong> {start_date?.toLocaleDateString()}  {startTime}</Typography>
                                <Typography><strong>End Date:</strong> {end_date?.toLocaleDateString()}  {endTime}</Typography>
                                <Typography className='mt-2'><strong>Trip Duration:</strong> {dateDifference} days</Typography>
                               
                                  <Typography className='fw-bold mt-2'><strong>SubTotal</strong>: TZS {updatedPrice}</Typography>
                                   <hr />
                                {/* <span class="fw-bold">Trip Extras</span>
                                  {selectedExtras.map((extra) => (
                                    <>
                                   
                                     <Typography variant='p' key={extra.name} className='mt-2 p-1 badge text-bg-light'>
                                    <strong>{extra.title} : </strong> TZS {extra.price}/trip
                                   </Typography>
                                   </>
                                  ))}
                                  <hr /> */}
                                {cars?.discount && (<Typography className='text-success mt-2'>
                                  <strong>Duration Discount:</strong> {cars.discount} </Typography>)}
                                  <Typography className='fw-bold mt-2'><strong>Total</strong>: TZS {totalPrice}</Typography>
                                <Divider style={{ margin: '10px 0' }} />
                                <Button variant="outlined" color="primary" onClick={handleToggleDetails} fullWidth
                                    style={{ marginTop: '10px' }} >  {openDetails ? 'Hide Details' : 'Show Details'}
                                </Button>
                                {openDetails && (
                                    <div style={{ marginTop: '10px' }}>
                                        <Typography><strong>Year:</strong> {cars?.year}</Typography>
                                        <Typography><strong>Make:</strong> {cars?.make}</Typography>
                                        <Typography><strong>Model:</strong> {cars?.model}</Typography>
                                        <Typography><strong>Seats:</strong> {cars?.seats}</Typography>
                                        <Typography><strong>Doors:</strong> {cars?.doors}</Typography>
                                        <Typography><strong>Description:</strong> {cars?.carDescription}</Typography>
                                    </div>
                                )}
                                <Divider style={{ margin: '10px 0' }} />
                            </Paper>
                        </Grid>
                    </Grid>
                </LocalizationProvider>
            </div>
        </>
    );
};

export default Car_booking;